import Instance from '../../../../Axios';

// New Actions for the app

const GetApartamentosReserva = () => async (dispatch) => {
  await Instance()
    .get(`/backend/reservas/apartamentos`)
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'GET_APARTAMENTOS', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetApartamentosReserva;
